import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { INoRowsOverlayParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { EmptyStateComponent } from '@ra-web-tech-ui-toolkit/components';
@Component({
  selector: 'app-no-rows-overlay',
  templateUrl: './ag-custom-no-rows-overlay.component.html',
  imports: [EmptyStateComponent],
})
export class AgCustomNoRowsOverlayComponent implements INoRowsOverlayAngularComp {
  public params: any = {
    title: '',
    content: '',
  };

  agInit(params: INoRowsOverlayParams): void {
    this.params = params;
  }
}
